import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { debounce } from "lodash";

const DEBOUNCE_DELAY = 150;

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function GlobalNotification() {
    const { message, severity, duration, version } = useSelector(
        (state) => state.notification
    );
    const [open, setOpen] = useState(false);

    const debouncedOpen = useMemo(
        () =>
            debounce((hasContent) => {
                setOpen(hasContent);
            }, DEBOUNCE_DELAY),
        []
    );

    useEffect(() => {
        const hasContent = Boolean(message && severity && duration);
        debouncedOpen(hasContent);
        return () => debouncedOpen.cancel();
        // include version so same text can retrigger
    }, [message, severity, duration, version, debouncedOpen]);

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        setOpen(false);
    };

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                autoHideDuration={duration}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity={severity || "info"} sx={{ width: "100%" }}>
                    {message}
                </Alert>
            </Snackbar>
        </Stack>
    );
}

export default GlobalNotification;
